export default __webpack_public_path__ + "559970b5dedb2268d4a2e98f5741cb45.png";